import styled from '@emotion/styled';
import { Link, CopyAction, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const CopyWrapper = styled.div`
  margin-left: ${tokens.spacer.x1};
`;

interface SurveyDetailsHeaderProps {
  surveyExternalLink: string;
}

export function SurveyExternalLink({ surveyExternalLink }: SurveyDetailsHeaderProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'surveys' });
  return (
    <Container>
      <Link kind="standalone" href={surveyExternalLink} isExternal>
        {surveyExternalLink}
      </Link>
      <CopyWrapper>
        <CopyAction toCopy={surveyExternalLink} description={t('external-link')} />
      </CopyWrapper>
    </Container>
  );
}
